import { createContext, useContext } from "react";

export const useDebugSettings = () => useContext(DebugSettingsContext);

export const DebugSettingsContext = createContext<DebugSettingsContextType>({
  enableDataLogging: false,
  enableContextPicker: false,
  setEnableDataLogging: () => {},
  setEnableContextPicker: () => {},
});

export interface DebugSettingsContextType {
  enableDataLogging: boolean;
  enableContextPicker: boolean;
  setEnableDataLogging: (value: boolean) => void;
  setEnableContextPicker: (value: boolean) => void;
}
